export var FilterType = /* @__PURE__ */ ((FilterType2) => {
  FilterType2["RANGE"] = "RANGE";
  FilterType2["CHECKBOX"] = "CHECKBOX";
  FilterType2["RADIO"] = "RADIO";
  return FilterType2;
})(FilterType || {});
